import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { ChartwizardTemplates } from '../../backend/backendapi';

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'SelectTemplateModal',
    components: {
    }
})
export default class SelectTemplateModal extends Vue {
    @Prop({ required: true })
    readonly templates!: ChartwizardTemplates | null;

    openModal(): void {
        $(this.$refs.modal!).modal('show');
    }

    closeModal(): void {
        $(this.$refs.modal!).modal('hide');
    }
}